import type { DefaultOptionType } from 'antd/es/select';

import type { ContainerTypeResponse } from './api';

export const normalizeContainerType = (list: ContainerTypeResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
